<template>
	<div class="flex items-center justify-between w-full gap-2">
		<div class="flex flex-col">
			<PageLabel
				:helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '')"
				v-if="
					(isConsumerEndOfLifeTabEnabled && $props.tabName === tabsDefinitions.consumerEndOfLife.value) ||
					$props.tabName !== tabsDefinitions.consumerEndOfLife.value
				"
				>{{ tabName + " - " + subTabName }}
			</PageLabel>
			<span
				v-if="isMultiOptionFeatureEnabled && $props.tabName === tabsDefinitions.distribution.value && selectedDistributionGeneralInfoName"
				class="text-lg text-gray-700 ml-1"
			>
				Distribution Name: <strong>{{ selectedDistributionGeneralInfoName }}</strong>
			</span>
		</div>

		<div
			class="flex flex-row items-center gap-2"
			v-if="
				(isConsumerEndOfLifeTabEnabled && $props.tabName === tabsDefinitions.consumerEndOfLife.value) ||
				$props.tabName !== tabsDefinitions.consumerEndOfLife.value
			"
		>
			<Button
				id="btnback"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read) && $props.tabName !== tabsDefinitions.consumerEndOfLife.value"
				@click.stop="changePage('prev')"
				>Back
				<!--:disabled="!nextPrevEnabled"-->
			</Button>
			<Button id="btnSaveGeneralInformation" @click.prevent="saveWaste(true)" v-bind="lock.button.value" v-tooltip="lock.tooltip">Save</Button>
			<Button
				id="btnNext"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read) && $props.tabName !== tabsDefinitions.consumerEndOfLife.value"
				:disabled="processWasteList.length === 0"
				@click.stop="changePage('next')"
			>
				Next
			</Button>
		</div>
	</div>
	<div
		class="flex items-center justify-between w-full gap-2"
		v-if="!isConsumerEndOfLifeTabEnabled && $props.tabName === tabsDefinitions.consumerEndOfLife.value"
	>
		<warningBlock :warningMessages="warningForConsumerEndOfLife"></warningBlock>
	</div>
	<div
		v-if="
			(isConsumerEndOfLifeTabEnabled && $props.tabName === tabsDefinitions.consumerEndOfLife.value) ||
			$props.tabName !== tabsDefinitions.consumerEndOfLife.value
		"
	>
		<div class="flex" v-if="$props.tabName !== tabsDefinitions.distribution.value && $props.tabName !== tabsDefinitions.consumerEndOfLife.value">
			<h2>{{ stepNumber + " - " + stepName }}</h2>
		</div>
		<div class="flex items-center justify-between w-full gap-2">
			<div class="grid grid-cols-2 gap-2 w-full">
				<div class="flex flex-col gap-2 w-full">
					<I2FormRow v-if="props.tabName !== tabsDefinitions.consumerEndOfLife.value">
						<I2FormField label="Notes" helpElementName="ProcessWasteNotes">
							<Textarea
								v-model="wasteNotes"
								placeholder="Please enter notes"
								rows="2"
								@change="updateProcessWasteBasicInfo()"
								v-bind="lock.input.value"
								v-tooltip="lock.tooltip"
							/>
						</I2FormField>
					</I2FormRow>
					<I2FormRow>
						<I2FormField label="Mass of Product Output" helpElementName="WasteMassOfProductOutput" v-if="props.tabName === tabsDefinitions.syntheticAPI.value"> {{ massOutput }} </I2FormField>
						<I2FormField label="Reference Unit" helpElementName="WasteReferenceUnit" v-if="props.tabName === tabsDefinitions.consumerEndOfLife.value"> {{ referenceUnit }} </I2FormField>
						<I2FormField label="Destination Setting" helpElementName="WasteDestinationSetting" v-if="props.tabName === tabsDefinitions.consumerEndOfLife.value">
							<Select
								v-model="selectedDestinationSetting"
								:options="destinationSettingLocations"
								optionLabel="consumerEolDestinationSettingName"
								option-value="id"
								placeholder="Select Destination Setting"
								:class="{ 'p-invalid': saveAttempted && selectedDestinationSetting == null, '': selectedDestinationSetting !== null }"
								@change="changeMarketSetting('setting', $event)"
								v-bind="lock.select.value"
								v-tooltip="lock.tooltip"
								style="width: 200px"
							>
							</Select>
						</I2FormField>
						<I2FormField
							label="Destination Market" helpElementName="WasteDestinationMarket"
							v-if="
								props.tabName === tabsDefinitions.consumerEndOfLife.value && isDestinationMarketRequired(selectedDestinationSetting)
							"
						>
							<Select
								v-model="selectedDestinationMarket"
								:options="destinationMarketLocations"
								optionLabel="consumerEolDestinationMarketName"
								option-value="id"
								placeholder="Select Destination Market"
								:class="{ 'p-invalid': saveAttempted && selectedDestinationMarket == null, '': selectedDestinationMarket !== null }"
								@change="changeMarketSetting('market', $event)"
								style="width: 200px"
								ref="destinationMarketDropdown"
								`
								v-bind="lock.select.value"
								v-tooltip="lock.tooltip"
							>
							</Select>
						</I2FormField>
					</I2FormRow>
					<I2FormRow>
						<I2FormField
							label="Site Location" helpElementName="WasteSiteLocation"
							v-if="props.tabName !== tabsDefinitions.consumerEndOfLife.value && props.tabName !== tabsDefinitions.distribution.value"
						>
							{{ selectedSite }}
						</I2FormField>
						<I2FormField label="Bulk Drug Substance (Dry Weight) Mass Output" helpElementName="WasteBulkDrugSubstanceMassOutput" v-if="props.tabName === tabsDefinitions.biologics.value">
							{{ massOutput }}
						</I2FormField>
					</I2FormRow>
					<I2FormRow>
						<I2FormField
							label="Unit Operations" helpElementName="WasteUnitOperations"
							v-if="props.tabName !== tabsDefinitions.consumerEndOfLife.value && props.tabName !== tabsDefinitions.distribution.value"
						>
							{{ selectedUnitOperation || "None Selected" }}
						</I2FormField>
						<I2FormField label="Mass of Product Output" helpElementName="WasteMassOfProductOutput" v-if="props.tabName === tabsDefinitions.biologics.value"> {{ massOutput2 }} </I2FormField>
					</I2FormRow>
				</div>

				<Image
					:src="image === undefined ? '' : `data:image/png;base64,${image}`"
					alt="Image"
					v-if="props.tabName === tabsDefinitions.syntheticAPI.value && image !== null && image !== '' && image !== undefined"
				/>
			</div>
		</div>
		<warningBlock v-if="tableErrorMessage" :warningMessages="[tableErrorMessage]" header="Warning" class="mb-4" />
		<div class="flex items-center justify-between w-full gap-2 4 6">
			<div class="flex flex-row items-center gap-2"></div>
			<div class="flex flex-row items-center gap-2">
				<Button
					id="btndefault"
					v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)"
					@click="confirmIfNeedToApplyDefaultValues"
					v-bind="lock.button.value"
					v-tooltip="lock.tooltip"
					>Apply Default Percentage</Button
				>
			</div>
		</div>
		<div>
			<DataTable
				:value="processWasteList"
				responsiveLayout="scroll"
				:row-hover="true"
				:paginator="false"
				:rows="tablePaginator == null ? 10 : tablePaginator.rows"
				:first="tablePaginator == null ? 0 : tablePaginator.first"
				:page="tablePaginator == null ? 0 : tablePaginator.page"
				@page="pageChanged($event)"
				paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
				:rowsPerPageOptions="[10, 20, 50]"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
				dataKey="id"
				v-model:filters="useFilters"
				filterDisplay="menu"
				:loading="loading1"
				:globalFilterFields="['materialName']"
				id="dtAssessmentList"
				v-readonly-lock
			>
				<template #empty> No materials found. </template>

				<template #loading>
					<div style="text-align: center; padding: 1rem">
						<FontAwesomeIcon v-if="!tableErrorMessage" :icon="['fa', 'spinner']" size="3x" class="text-blue-500 3 ml-2" spin />
						<p v-else style="color: white !important">
							{{
								tabsDefinitions.packaging.value === props.tabName &&
								selectedDestinationSetting !== "A21535A8-8898-4A6C-A0E6-FBA73319C993" &&
								selectedDestinationMarket === undefined
									? "Please select Destination Market"
									: "Loading data, please wait..."
							}}
						</p>
					</div>
				</template>
				<Column
					field="material"
					filterField="material"
					style="flex: 0 0 30%"
				>
				<template #header>
						<I2Label
							:label="$props.tabName === tabsDefinitions.consumerEndOfLife.value ? 'Component Name' : $props.tabName === tabsDefinitions.distribution.value ? 'Waste Type' : 'Material Type'"
							:helpElementName="$props.tabName === tabsDefinitions.consumerEndOfLife.value ? 'WasteColComponentName' : $props.tabName === tabsDefinitions.distribution.value ? 'WasteColDistributionWasteType' : 'WasteColMaterialType'"
						/>
				</template>
					<template #body="{ data }">
						<div>{{ data.materialTypeName }}</div>
					</template>
				</Column>
				<Column
					field="material"
					filterField="material"
					v-if="$props.tabName === tabsDefinitions.consumerEndOfLife.value"
					style="flex: 0 0 30%"
				>
				<template #header><I2Label label="Waste Type" helpElementName="WasteColConsumerWasteType" /></template>
					<template #body="{ data }">
						<div>{{ data.materialName }}</div>
					</template>
				</Column>
				<!-- <Column
			v-if="$props.tabName === tabsDefinitions.distribution.value"
			field="materialName"
			filterField="materialName"
			:header="'Waste Type'"
			style="flex: 0 0 30%"
		>
			<template #body="{ data }">
				<div>{{ data.materialName }}</div>
			</template>
		</Column> -->

				<Column field="totalMass" filterField="totalMass" style="flex: 0 0 30%">
					<template #header><I2Label label="Total Mass (kg)" helpElementName="WasteColTotalMass" /></template>
					<template #body="{ data }">
						<div>{{ formatDecimal(data.totalMass) }}</div>
					</template> </Column
				><Column field="sterilizationDisposal" filterField="sterilizationDisposal" style="flex: 0 0 30%">
					<template #header><I2Label label="Sterilization before Disposal?" helpElementName="WasteColSterilizationBeforeDisposal" /></template>
					<template #body="{ data, index }">
						<Select
							v-model="data.sterilizationDisposal"
							:options="yesOrNo"
							optionLabel="text"
							option-value="value"
							placeholder="Select"
							class="w-full md:w-14rem"
							@change="changedCellContent('sterilizationDisposal', index)"
							v-bind="lock.select.value"
							v-tooltip="lock.tooltip"
						>
						</Select>
					</template> </Column
				><Column
					field="hazardWasteIncineration"
					filterField="hazardWasteIncineration"
					style="flex: 0 0 30%"
				>
					<template #header><I2Label label="Hazardous Waste Incineration (%)" helpElementName="WasteColHazardousWasteIncineration" /></template>
					<template #body="{ data, index }">
						<InputText
							v-model="data.hazardWasteIncineration"
							@keypress="onlyNuers($event)"
							@change="changedCellContent('hazardWasteIncineration', index)"
							style="width: 80px"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</template> </Column
				><Column field="landfill" filterField="landfill" style="flex: 0 0 30%">
					<template #header><I2Label label="Landfill (%)" helpElementName="WasteColLandfill" /></template>
					<template #body="{ data, index }">
						<InputText
							v-model="data.landfill"
							@keypress="onlyNuers($event)"
							@change="changedCellContent('landfill', index)"
							style="width: 80px"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</template> </Column
				><Column field="recycling" filterField="recycling" style="flex: 0 0 30%">
					<template #header><I2Label label="Recycling (%)" helpElementName="WasteColRecycling" /></template>
					<template #body="{ data, index }">
						<InputText
							v-model="data.recycling"
							@keypress="onlyNuers($event)"
							@change="changedCellContent('recycling', index)"
							style="width: 80px"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</template> </Column
				><Column
					field="generalWasteIncinerationEnergy"
					filterField="generalWasteIncinerationEnergy"
					style="flex: 0 0 30%"
				>
					<template #header><I2Label label="General Waste Incineration with energy recovery (%)" helpElementName="WasteColGeneralWasteIncinerationEnergy" /></template>
					<template #body="{ data, index }">
						<InputText
							v-model="data.generalWasteIncinerationEnergy"
							@keypress="onlyNuers($event)"
							@change="changedCellContent('generalWasteIncinerationEnergy', index)"
							style="width: 80px"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</template> </Column
				><Column
					field="generalWasteIncinerationEnergyNoEnergy"
					filterField="generalWasteIncinerationEnergyNoEnergy"
					style="flex: 0 0 30%"
				>
					<template #header><I2Label label="General Waste Incineration without energy recovery (%)" helpElementName="WasteColGeneralWasteIncinerationEnergyNoEnergy" /></template>
					<template #body="{ data, index }">
						<InputText
							v-model="data.generalWasteIncinerationEnergyNoEnergy"
							@keypress="onlyNuers($event)"
							@change="changedCellContent('generalWasteIncinerationEnergyNoEnergy', index)"
							style="width: 80px"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</template> </Column
				><Column
					field="municipalWastewaterTreatment"
					filterField="municipalWastewaterTreatment"
					style="flex: 0 0 30%"
					v-if="props.tabName !== tabsDefinitions.consumerEndOfLife.value"
				>
					<template #header><I2Label label="Municipal Wastewater Treatment (%)" helpElementName="WasteColMunicipalWastewaterTreatment" /></template>
					<template #body="{ data, index }">
						<InputText
							v-model="data.municipalWastewaterTreatment"
							@keypress="onlyNuers($event)"
							@change="changedCellContent('municipalWastewaterTreatment', index)"
							style="width: 80px"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</template> </Column
				><Column field="total" filterField="total" style="flex: 0 0 30%">
					<template #header><I2Label label="Total (%)" helpElementName="WasteColTotal" /></template>
					<template #body="{ data, index }">
						<div :style="'color:' + checkIfTotalIs100(data.total) + (data.total != 100 ? ';font-weight:bold;' : '')">
							<b>{{ data.total }}</b>
						</div>
					</template>
				</Column></DataTable
			>
		</div>
	</div>
</template>
<script setup lang="ts">
import { ref, onMounted, reactive, nextTick, inject, watch, type Ref } from "vue"
import { SessionInfo, PageAccess } from "../auth/personSessionData"
import { FilterMatchMode, FilterOperator } from "@primevue/core/api"
import { EventBus } from "../eventBus"
import Image from "primevue/image"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import Textarea from "primevue/textarea"
import InputText from "primevue/inputtext"
import {
	ApiClient,
	RawMaterialEntry,
	ProcessWasteInput,
	ProcessWaste,
	ProcessWasteRowInTable,
	FeatureFlagClient,
} from "../../entities/NSwagGenerated"
import { library } from "@fortawesome/fontawesome-svg-core"
import { useToast } from "primevue/usetoast"
import { useConfirm } from "primevue/useconfirm"
import warningBlock from "./warningBlock.vue"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { uiNumberFormatterAZ } from "../composables/AZGlobalFunctions"

library.add(faSpinner)
import { useToaster, useErrorToaster, SystemToastOptions } from "../composables/toaster"
import Button from "primevue/button"
import { useHistoryHelper } from "../composables/historyHelper"
const toast = useToast()
import { useTabsDefinitions } from "../composables/tabsDefinitions"
import { useAssessmentStore } from "@/store/assessmentStore"
import { useAssessmentLock } from "@/composables/assessmentLock"

const assessmentStore = useAssessmentStore()
const lock = useAssessmentLock(assessmentStore)
const tabsDefinitions = useTabsDefinitions()
const { updateAssessmentUpdatedByDate } = useHistoryHelper()
const warningForConsumerEndOfLife = ["Device & Packaging needs at least one material to enable this tab.</b>"]
const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
const featureFlagClient = new FeatureFlagClient(import.meta.env.VITE_API_URL?.toString())
const confirm = useConfirm()
const props = defineProps({
	assessmentId: {
		type: String,
		required: true,
		default: "",
	},
	tabName: {
		type: String,
		required: true,
		default: "",
	},
	tabId: {
		type: String,
		required: true,
		default: "",
	},
	subTabName: {
		type: String,
		required: true,
		default: "",
	},
	allTabsInformation: {
		type: Object,
		required: true,
		default: "",
	},
})
const selectedStepName = ref()
const actualStepId = ref()
const actualGeneralInformation = ref()
const actualProcessWasteId = ref("")
actualGeneralInformation.value = ""
const concentrationOutput = ref()
const selectedConcentrationUnit = ref()
const proteinMassOutput = ref()
const proteinMassOutputUnit = ref()
const unitsWeight = ref()
const massOutput = ref()
const massOutput2 = ref()
const selectedSite = ref()
const image = ref()
const selectedUnitOperation = ref()
const wasteNotes = ref()
const loading1 = ref(false)
const processWasteList = ref([] as ProcessWasteRowInTable[])
let tablePaginator: any | null = null

let useFilters = reactive({
	global: { value: null, matchMode: FilterMatchMode.CONTAINS },
	projectName: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
})
let rawMaterialEntries = ref([] as RawMaterialEntry[])
const editLineId = ref()
const editMode = ref()
editMode.value = "cell"
let yesOrNo = [
	{
		text: "Yes",
		value: true,
	},
	{
		text: "No",
		value: false,
	},
]

const readyToSave = ref(false)

const thisStepStatus = ref(false)
const tableErrorMessage = ref<string | null>(null)

const nextPrevEnabled = ref(false)

const stepName = ref("")
const stepNumber = ref("")
//refs
interface PrimeVueDropdownInstance {
	$el: HTMLElement
}
const destinationMarketDropdown = ref<PrimeVueDropdownInstance | null>(null)

//consumer eol
const referenceUnit = ref()
const selectedDestinationMarket = ref<string | undefined>(undefined)
const destinationMarketLocations = ref()
const selectedDestinationSetting = ref<string | undefined>(undefined)
const destinationSettingLocations = ref()
const selectedDestinationMarketDefinitive = ref<string | undefined>(undefined)
const nonHouseholdRegionId = ref<string | undefined>(undefined)
const destinationMarketRequiredSettingId = ref<string | undefined>(undefined)
let saveAttempted = ref(false)
const processWasteId = ref()
const isConsumerEndOfLifeTabEnabled = ref(false)
const isMultiOptionFeatureEnabled = ref(false)
const selectedPackagingGeneralInfoName = ref<string | null>(null)
const selectedDistributionGeneralInfoName = ref<string | null>(null)
// Consumer End of Life reuses the Packaging options selector provided by commonTabs (provide/inject).
// Holds the packaging generalInformation id the user is currently viewing on this tab.
const selectedPackagingOption = inject<Ref<string | null>>("selectedPackagingOption", ref(null))
const normalizeGuid = (value: string | undefined | null) => value?.toLowerCase()
const isDestinationMarketRequired = (destinationSettingId: string | undefined | null) =>
	!!destinationSettingId && normalizeGuid(destinationSettingId) === normalizeGuid(destinationMarketRequiredSettingId.value)
const isNonHouseholdRegion = (destinationMarketId: string | undefined | null) =>
	!!destinationMarketId && normalizeGuid(destinationMarketId) === normalizeGuid(nonHouseholdRegionId.value)
class tabActualStatus {
	actualMainTabId: string
	actualSubTabName: string
	selectedStepId: string
	generalInformationId: string
}

const checkIfEnableConsumerEndOfLifeTab = async (): Promise<boolean> => {
	try {
		if (props.tabName === tabsDefinitions.consumerEndOfLife.value) {
			const res = await apiClient.checkIfEnableConsumerEndOfLifeTab(props.assessmentId, selectedPackagingOption.value ?? undefined)
			isConsumerEndOfLifeTabEnabled.value = res
			return res
		} else return true
	} catch (error) {
		throw new Error(`Error from API: ${error}`)
	}
}

class allTabsActualStatus {
	public allTabsStatus: tabActualStatus[]
}
const emit = defineEmits(["updateAllTabsInformation"])
const setTabInfoGlobally = (type: string, tabId: string, tabContent: any) => {
	switch (type) {
		case "selectedStepId":
			props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === tabId).selectedStepId = tabContent
			break
		case "generalInformationId":
			props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === tabId).generalInformationId = tabContent
			break
	}
	emit("updateAllTabsInformation", props.allTabsInformation)
}
const confirmIfNeedToApplyDefaultValues = () => {
	confirm.require({
		message: "Are you sure you want to apply default percentage values?",
		header: "Default Confirmation",
		icon: "pi pi-info-circle",
		rejectClass: "mr-4",
		acceptClass: "",
		accept: () => {
			fillProcessWasteMaterialTable("default")
		},
		reject: () => {},
	})
}
function formatDecimal(num: number) {
	return num != null ? uiNumberFormatterAZ(num) : num
}

function updateProcessWasteBasicInfo() {
	let processWaste = new ProcessWaste()
	processWaste.id = actualProcessWasteId.value === "" ? self.crypto.randomUUID() : actualProcessWasteId.value
	processWaste.notes = wasteNotes.value
	processWaste.pmConcentration = concentrationOutput.value
	processWaste.pmUnitId = selectedConcentrationUnit.value
	processWaste.pmOutput = proteinMassOutput.value
	processWaste.pmOutputUnitId = proteinMassOutputUnit.value
	processWaste.stepId = actualStepId.value
	processWaste.screenId = props.tabId
	apiClient.putProcessWasteBasicInfo(processWaste).then((res) => {
		if (res.id) actualProcessWasteId.value = res.id
	})
}

function checkIfTotalIs100(total: number) {
	if (total > 100 || total < 100) return "red"
	else "black"
}

onMounted(async () => {
	//console.log(selectedDestinationMarketDefinitive.value, selectedDestinationSetting.value)
	getConsumerEndOfLifeRelatedDropdowns()

	// Load multi-option feature flag for Consumer EOL tab and Distribution tab
	if (props.tabName === tabsDefinitions.consumerEndOfLife.value || props.tabName === tabsDefinitions.distribution.value) {
		try {
			const featureFlag = await featureFlagClient.getByName("Allow Multiple Packaging Options per Assessment")
			isMultiOptionFeatureEnabled.value = featureFlag.isEnabled || false
		} catch (error) {
			isMultiOptionFeatureEnabled.value = false
		}
	}

	EventBus.on("selectedStep_" + props.tabId, (data: any) => {
		selectedStepName.value = data.stepName

		actualStepId.value = data.id
		actualGeneralInformation.value = data.generalInformationId

		stepName.value = data.stepName
		stepNumber.value = data.stepNumber
	})
	EventBus.on("ProcessWasteUpdate" + props.tabId, async () => {
		// Load packaging name for Consumer EOL tab BEFORE any checks
		if (props.tabName === tabsDefinitions.consumerEndOfLife.value && isMultiOptionFeatureEnabled.value) {
			try {
				// Get packaging options directly from API using packaging screenId
				const packagingScreenId = "62cdd11a-f63f-49bc-8282-898e5e8f7334"
				const packagingOptions = await apiClient.getCommonAPIGeneralByAssessmentIdAndScreenId(props.assessmentId, packagingScreenId)
				const activeOptions = packagingOptions.filter((gi: any) => gi.isActive === true)
				// Prefer the packaging option chosen in the selector, then wasSelected, then the first one
				const selectedOption =
					(selectedPackagingOption.value ? activeOptions.find((gi: any) => gi.id === selectedPackagingOption.value) : null) ||
					activeOptions.find((gi: any) => gi.wasSelected === true) ||
					activeOptions[0]
				if (selectedOption) {
					selectedPackagingGeneralInfoName.value = selectedOption.generalInformationName || null
				}
			} catch (error) {
				selectedPackagingGeneralInfoName.value = null
			}
		}

		const enabled = await checkIfEnableConsumerEndOfLifeTab()
		if (!enabled && props.tabName === tabsDefinitions.consumerEndOfLife.value) return
		wasteNotes.value = ""
		selectedConcentrationUnit.value = null
		concentrationOutput.value = null
		proteinMassOutput.value = null
		proteinMassOutputUnit.value = null
		setPrimaryInformation()
			.then((res) => {
				return res
			})
			.then((res) => {
				if (res === "Done") {
					nextTick()
					fillProcessWasteMaterialTable("actual")
				}
			})
	})
	EventBus.on("nextPrevEnabled_" + props.tabId, () => {
		nextPrevEnabled.value = true
	})
})

// Reload the Consumer End of Life data when the user picks a different packaging option
// in the selector. The initial default selection (null -> first/wasSelected) is skipped
// because the tab already loads that option through the ProcessWasteUpdate flow.
watch(
	() => selectedPackagingOption.value,
	async (newId, oldId) => {
		if (props.tabName !== tabsDefinitions.consumerEndOfLife.value) return
		if (!oldId || !newId || newId === oldId) return
		const enabled = await checkIfEnableConsumerEndOfLifeTab()
		if (!enabled) return
		const res = await setPrimaryInformation()
		if (res === "Done") fillProcessWasteMaterialTable("actual")
	}
)

function checkIfSiteLocationIsSelectedInRawMaterialsForSyntheticAPI(): Boolean {
	//console.log("actualStepId", actualStepId.value)
	let result = false
	apiClient.checkIfSiteLocationIsSelectedInRawMaterialsForSyntheticAPI(actualStepId.value).then((res) => {
		if (!res) {
			toast.add({
				severity: "error",
				summary: "Process Waste need Site Location to be selected",
				detail: `Please go to the Raw Material tab and select Site Location.`,
				life: 3000,
			})
			result = false
		} else {
			result = true
		}
	})
	return result
}

function onlyNuers(evt: any) {
	evt = evt ? evt : window.event
	var charCode = evt.which ? evt.which : evt.keyCode
	//if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
	if (
		(charCode != 46 || evt.target.value.indexOf(".") != -1) && // “.” CHECK DOT, AND ONLY ONE.
		(charCode < 48 || charCode > 57)
	) {
		evt.preventDefault()
		return false
	} else {
		return true
	}
}

function changeMarketSetting(type: string, event: any) {
	//console.log(event)
	let updateWaste = true
	if (props.tabName === tabsDefinitions.consumerEndOfLife.value) {
		switch (type) {
			case "setting":
				if (isDestinationMarketRequired(selectedDestinationSetting.value)) {
					selectedDestinationMarketDefinitive.value = undefined
					selectedDestinationMarket.value = undefined
					//destinationMarketDropdown.value!.$el.click()
					updateWaste = false
					processWasteList.value = [] as ProcessWasteRowInTable[]
					nextTick(() => {
						if (destinationMarketDropdown.value) destinationMarketDropdown.value!.$el.click()
					})
					loading1.value = false
				} else {
					selectedDestinationMarketDefinitive.value = nonHouseholdRegionId.value
					selectedDestinationMarket.value = nonHouseholdRegionId.value
					updateWaste = true
				}

				break
			case "market":
				selectedDestinationMarketDefinitive.value = selectedDestinationMarket.value

				updateWaste = true

				break
		}
	}

	if (updateWaste) {
		apiClient
			.putConsumerProcessWaste(processWasteId.value, selectedDestinationMarketDefinitive.value, selectedDestinationSetting.value)
			.then((res) => {})

		fillProcessWasteMaterialTable("new")
	}
}

function changePage(action: string) {
	if (action === "next") {
		if (!assessmentStore.isLocked) {
			saveWaste(true)
		}
	}
	EventBus.emit("nextPreviousTab_" + props.tabId, {
		action: action,
		actualTab: props.tabId,
	})
}

function setPrimaryInformation(): Promise<string> {
	if (props.tabName === tabsDefinitions.consumerEndOfLife.value) {
		return new Promise((resolve, reject) => {
			apiClient.generateBasicInfoForConsumerEolTab(props.assessmentId, props.tabId, selectedPackagingOption.value ?? undefined).then((res) => {
				// console.log("generateBasicInfoForConsumerEolTab", res)
				// var tabStatus: allTabsActualStatus = JSON.parse(localStorage.getItem("actualTabsStatus")) as allTabsActualStatus
				// var toUpdate = tabStatus.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId)
				// toUpdate.selectedStepId = res.step.id
				setTabInfoGlobally("selectedStepId", props.tabId, res.step.id)
				if (props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).generalInformationId === undefined) {
					// toUpdate.generalInformationId = res.generalInformation.id ? res.generalInformation.id : ""
					// localStorage.setItem("actualTabsStatus", JSON.stringify(tabStatus))
					setTabInfoGlobally("generalInformationId", props.tabId, res.generalInformation.id)
				}
				var data = {
					stepName: res.step.stepName,
					stepNumber: 1,
					id: res.step.id,
					generalInformationId: res.generalInformation.id,
				}
				selectedStepName.value = data.stepName
				processWasteId.value = res.storedProcessWaste.id
				selectedDestinationSetting.value = res.storedProcessWaste.eolDestinationSetting
				// setTimeout(() => {
				selectedDestinationMarket.value = res.storedProcessWaste.eolDestinationMarket
				selectedDestinationMarketDefinitive.value = res.storedProcessWaste.eolDestinationMarket
				// }, 200)

				actualStepId.value = data.id
				actualGeneralInformation.value = data.generalInformationId
				referenceUnit.value = res.generalInformation?.packReferenceUnitId ? res.generalInformation.packReferenceUnit?.valueTxt : null
				// Save the generalInformation name for display when multi-option is enabled
				selectedPackagingGeneralInfoName.value = res.generalInformation?.generalInformationName || null
				resolve("Done")
			})
		})
	} else {
		return new Promise(async (resolve, reject) => {
			//selectedStepName.value = toGetStatus.actualSubTabName
			actualStepId.value = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).selectedStepId
			actualGeneralInformation.value = props.allTabsInformation.allTabsStatus.find(
				(item: any) => item.actualMainTabId === props.tabId
			).generalInformationId

			// For Distribution tab, fetch the generalInformation name to display when multi-option is enabled
			if (props.tabName === tabsDefinitions.distribution.value && isMultiOptionFeatureEnabled.value && actualGeneralInformation.value) {
				try {
					const genInfo = await apiClient.getGeneralInformationById(actualGeneralInformation.value, undefined)
					selectedDistributionGeneralInfoName.value = genInfo?.generalInformationName || null
				} catch (error) {
					selectedDistributionGeneralInfoName.value = null
				}
			}

			resolve("Done")
		})
	}
}

function getConsumerEndOfLifeRelatedDropdowns(): Promise<string> {
	return new Promise((resolve, reject) => {
		apiClient
			.getConsumerEndOfLifeDropdowns()
			.then((res) => {
				nonHouseholdRegionId.value = res.nonHouseholdRegionId
				destinationMarketRequiredSettingId.value = res.destinationMarketRequiredSettingId
				destinationMarketLocations.value = res.destinationMarkets.filter((item: any) => normalizeGuid(item.id) !== normalizeGuid(nonHouseholdRegionId.value))
				destinationSettingLocations.value = res.destinationSettings
			})
			.then(() => {
				resolve("Done")
			})
	})
}

function checkIfEmptyPlaceZero(data: any) {
	return data === null || data === "" || data === undefined ? 0 : data
}

function changedCellContent(type: string, index: nuer) {
	switch (type) {
		case "sterilizationDisposal":
			break
		case "hazardWasteIncineration":
			processWasteList.value[index].hazardWasteIncineration = checkIfZero(processWasteList.value[index].hazardWasteIncineration)
			break
		case "landfill":
			processWasteList.value[index].landfill = checkIfZero(processWasteList.value[index].landfill)
			break
		case "recycling":
			processWasteList.value[index].recycling = checkIfZero(processWasteList.value[index].recycling)
			break
		case "generalWasteIncinerationEnergy":
			processWasteList.value[index].generalWasteIncinerationEnergy = checkIfZero(processWasteList.value[index].generalWasteIncinerationEnergy)
			break
		case "generalWasteIncinerationEnergyNoEnergy":
			processWasteList.value[index].generalWasteIncinerationEnergyNoEnergy = checkIfZero(
				processWasteList.value[index].generalWasteIncinerationEnergyNoEnergy
			)
			break
		case "municipalWastewaterTreatment":
			processWasteList.value[index].municipalWastewaterTreatment = checkIfZero(processWasteList.value[index].municipalWastewaterTreatment)
			break
	}

	processWasteList.value[index].total = parseFloat(
		(
			parseFloat(processWasteList.value[index].hazardWasteIncineration.toString()) +
			parseFloat(processWasteList.value[index].landfill.toString()) +
			parseFloat(processWasteList.value[index].recycling.toString()) +
			parseFloat(processWasteList.value[index].generalWasteIncinerationEnergy.toString()) +
			parseFloat(processWasteList.value[index].generalWasteIncinerationEnergyNoEnergy.toString()) +
			parseFloat(processWasteList.value[index].municipalWastewaterTreatment.toString())
		).toFixed(2)
	)
	//readyToSave.value = checkIfAll100()
	if (processWasteList.value[index].total === 100) {
		saveWaste(false)
	}
}
function checkIfZero(data: any) {
	return data === null || data === "" || data === undefined ? 0 : data
}
function onCellEditComplete(ev: any) {
	const index = processWasteList.value.findIndex((item) => item.id === ev.newData.id)
	if (index !== -1) {
		Object.assign(processWasteList.value[index], ev.newData)
		switch (ev.field) {
			case "hazardWasteIncineration":
				processWasteList.value[index].hazardWasteIncineration = checkIfEmptyPlaceZero(ev.newData.hazardWasteIncineration)
				break
			case "landfill":
				processWasteList.value[index].landfill = checkIfEmptyPlaceZero(ev.newData.landfill)
				break
			case "recycling":
				processWasteList.value[index].recycling = checkIfEmptyPlaceZero(ev.newData.recycling)
				break
			case "generalWasteIncinerationEnergy":
				processWasteList.value[index].generalWasteIncinerationEnergy = checkIfEmptyPlaceZero(ev.newData.generalWasteIncinerationEnergy)
				break
			case "generalWasteIncinerationEnergyNoEnergy":
				processWasteList.value[index].generalWasteIncinerationEnergyNoEnergy = checkIfEmptyPlaceZero(
					ev.newData.generalWasteIncinerationEnergyNoEnergy
				)
				break
			case "municipalWastewaterTreatment":
				processWasteList.value[index].municipalWastewaterTreatment = checkIfEmptyPlaceZero(ev.newData.municipalWastewaterTreatment)
				break
			case "sterilizationBeforeDisposal":
				processWasteList.value[index].hazardWasteIncineration = checkIfEmptyPlaceZero(ev.newData.hazardWasteIncineration)
				break
		}
		processWasteList.value[index].total = parseFloat(
			(
				parseFloat(processWasteList.value[index].hazardWasteIncineration.toString()) +
				parseFloat(processWasteList.value[index].landfill.toString()) +
				parseFloat(processWasteList.value[index].recycling.toString()) +
				parseFloat(processWasteList.value[index].generalWasteIncinerationEnergy.toString()) +
				parseFloat(processWasteList.value[index].generalWasteIncinerationEnergyNoEnergy.toString()) +
				parseFloat(processWasteList.value[index].municipalWastewaterTreatment.toString())
			).toFixed(2)
		)
	}
	readyToSave.value = checkIfAll100()
}

function updateAllSums() {
	processWasteList.value.forEach((single) => {
		single.total = parseFloat(
			(
				parseFloat(single.hazardWasteIncineration.toString()) +
				parseFloat(single.landfill.toString()) +
				parseFloat(single.recycling.toString()) +
				parseFloat(single.generalWasteIncinerationEnergy.toString()) +
				parseFloat(single.generalWasteIncinerationEnergyNoEnergy.toString()) +
				parseFloat(single.municipalWastewaterTreatment.toString())
			).toFixed(2)
		)
	})
}

function checkIfAll100() {
	let result = true
	processWasteList.value.forEach((single) => {
		if (single.total !== 100) result = false
	})
	return result
}
//getData action can be "actual" or "default"
function fillProcessWasteMaterialTable(action: string) {
	//&&	props.tabName === tabsDefinitions.consumerEndOfLife.value

	loading1.value = true
	tableErrorMessage.value = null

	let region = props.tabName === tabsDefinitions.consumerEndOfLife.value ? selectedDestinationMarketDefinitive.value : undefined
	//console.log(props.assessmentId, actualGeneralInformation.value, props.tabId, actualStepId.value, action, region)

	if (
		(isDestinationMarketRequired(selectedDestinationSetting.value) && isNonHouseholdRegion(selectedDestinationMarketDefinitive.value)) ||
		selectedDestinationMarketDefinitive.value === null ||
		(selectedDestinationSetting.value === null && props.tabName === tabsDefinitions.consumerEndOfLife.value)
	) {
		processWasteList.value = [] // Clear table when destination settings are incomplete
		loading1.value = false // Stop loading indicator
		return
	}

	// if (
	// 	selectedDestinationMarketDefinitive.value === null ||
	// 	(selectedDestinationSetting.value === null && props.tabName === tabsDefinitions.consumerEndOfLife.value)
	// )
	// 	return
	processWasteList.value = []

	//console.log(selectedDestinationMarketDefinitive.value, selectedDestinationSetting.value)
	//return
	actualGeneralInformation.value =
		props.tabName === tabsDefinitions.consumerEndOfLife.value ? "00000000-0000-0000-0000-000000000000" : actualGeneralInformation.value

	if (props.tabName === tabsDefinitions.consumerEndOfLife.value && (region === undefined || selectedDestinationSetting.value === undefined)) {
		loading1.value = false // Stop loading indicator
		return
	}

	apiClient
		.populateProcessWasteAndTable(
			props.assessmentId,
			actualGeneralInformation.value,
			props.tabId,
			actualStepId.value,
			action,
			region,
			selectedPackagingOption.value ?? undefined
		)
		.then(
			(res) => {
				// Handle warnings from API response (cast to any since TypeScript types may not be regenerated yet)
				const resAny = res as any
				if (resAny.warnings && resAny.warnings.length > 0) {
					tableErrorMessage.value = resAny.warnings.join("<br>")
				} else {
					tableErrorMessage.value = null
				}

				if (res.waste) {
					wasteNotes.value = res.waste.notes
					actualProcessWasteId.value = res.waste.id
					if (props.tabName !== tabsDefinitions.consumerEndOfLife.value && props.tabName !== tabsDefinitions.distribution.value) {
						massOutput.value =
							props.tabName !== tabsDefinitions.biologics.value
								? res.rawMaterial.massOfProduct + " " + res.rawMaterial.unit.unitName
								: res.rawMaterial.generalInformation.proteinMassOutput + " " + res.rawMaterial.generalInformation.proteinMOUnit.unitName
						massOutput2.value =
							props.tabName !== tabsDefinitions.biologics.value
								? res.rawMaterial.massOfProduct + " " + res.rawMaterial.unit.unitName
								: res.rawMaterial.generalInformation.concProteinMassProdOutput + " " + res.rawMaterial.generalInformation.concentrationUnit.unitName
						selectedSite.value =
							props.tabName !== tabsDefinitions.biologics.value
								? res.rawMaterial.siteLocation.siteLocationName
								: res.rawMaterial.generalInformation.siteLocation.siteLocationName
						image.value = res.rawMaterial.image ? res.rawMaterial.image : ""
						selectedConcentrationUnit.value = res.waste.pmUnitId
						concentrationOutput.value = res.waste.pmConcentration
						proteinMassOutput.value = res.waste.pmOutput
						proteinMassOutputUnit.value = res.waste.pmOutputUnitId
						selectedUnitOperation.value =
							props.tabName !== tabsDefinitions.biologics.value && props.tabName !== tabsDefinitions.productProcess.value
								? res.rawMaterial.rawMaterialUnitOperation
										?.filter((item) => item.isActive == true)
										.sort((a, b) => a.position - b.position)
										.map((item) => item.unitOperation?.unitOperationName)
										.filter(Boolean)
										.join(", ") || "None Selected"
								: res.rawMaterial.step?.unitOperation?.unitOperationName ?? res.rawMaterial.step?.stepName ?? "None Selected"
						loading1.value = false
					} else {
						//referenceUnit.value = props.tabName === tabsDefinitions.consumerEndOfLife.value ? res.generalInformation.packReferenceUnit.valueTxt : null
					}

					//processWasteList.value = res.waste.processWasteDetail
					if (res.allWasteRows !== undefined)
						processWasteList.value =
							props.tabName === tabsDefinitions.distribution.value
								? res.allWasteRows.sort((a, b) => {
										const materialA = String(a.materialTypeName || "").toLowerCase()
										const materialB = String(b.materialTypeName || "").toLowerCase()

										if (materialA < materialB) return -1
										if (materialA > materialB) return 1
										return 0
									})
								: res.allWasteRows
					thisStepStatus.value = true
					loading1.value = false
				} else {
					wasteNotes.value = ""
					selectedConcentrationUnit.value = null
					concentrationOutput.value = null
					proteinMassOutput.value = null
					proteinMassOutputUnit.value = null
					thisStepStatus.value = false
					loading1.value = false
				}
			},
			(err) => {
				useErrorToaster(err)
				// Extract error message for table display (same as toast, exclude error ID)
				let errorData: any = null

				// Check if error has response property (NSwag APIException)
				if (err?.response) {
					// response could be a string or already parsed object
					if (typeof err.response === "string") {
						try {
							errorData = JSON.parse(err.response)
						} catch {
							errorData = null
						}
					} else {
						errorData = err.response
					}
				} else if (err?.result) {
					errorData = err.result
				}

				if (errorData && errorData.message) {
					tableErrorMessage.value = errorData.message + (errorData.supportMessage ? "\n" + errorData.supportMessage : "")
				} else {
					tableErrorMessage.value = "An error occurred while loading data"
				}
				loading1.value = false
			}
		)
		.then((res) => {
			if (res !== null) {
				updateAllSums()
				readyToSave.value = checkIfAll100()
			}
		})
}

// function applyFilter() {}

// function applyDefaultsDialog() {
// }

function pageChanged(ev: Event) {
	tablePaginator = ev
	localStorage.setItem("projectListPaginate", JSON.stringify(ev))
}

const checkDestinationMarketSetting = (): Boolean => {
	let checkFailed = false
	if (props.tabName === tabsDefinitions.consumerEndOfLife.value) {
		if (!selectedDestinationSetting.value) checkFailed = true
		if (isDestinationMarketRequired(selectedDestinationSetting.value)) {
			if (!selectedDestinationMarket.value || isNonHouseholdRegion(selectedDestinationMarket.value)) checkFailed = true
		}

		if (checkFailed) {
			let msg: SystemToastOptions = {
				severity: "error",
				summary: "Error",
				detail: "Please complete the highlighted fields before save.",
			}

			useToaster(msg)
			return false
		}
	}
	return true
}
function saveWaste(showMessage: boolean) {
	saveAttempted.value = true
	if (!checkDestinationMarketSetting()) return

	actualStepId.value = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).selectedStepId
	actualGeneralInformation.value = props.allTabsInformation.allTabsStatus.find(
		(item: any) => item.actualMainTabId === props.tabId
	).generalInformationId
	let processWaste = new ProcessWaste()
	processWaste.id = actualProcessWasteId.value === "" ? self.crypto.randomUUID() : actualProcessWasteId.value
	processWaste.notes = wasteNotes.value
	processWaste.pmConcentration = concentrationOutput.value
	processWaste.pmUnitId = selectedConcentrationUnit.value
	processWaste.pmOutput = proteinMassOutput.value
	processWaste.pmOutputUnitId = proteinMassOutputUnit.value
	processWaste.stepId = actualStepId.value
	processWaste.screenId = props.tabId
	processWaste.eolDestinationMarket = selectedDestinationMarketDefinitive.value
	processWaste.eolDestinationSetting = selectedDestinationSetting.value
	let processWasteInput = new ProcessWasteInput()
	processWasteInput.details = processWasteList.value
	processWasteInput.waste = processWaste
	//console.log("save", processWasteInput)
	apiClient.putProcessWaste(processWasteInput).then(
		(res) => {
			if (res.waste?.id) actualProcessWasteId.value = res.waste.id
			if (showMessage)
				toast.add({
					severity: "success",
					summary: "Process Waste saved",
					detail: ``,
					life: 3000,
				})
			updateAssessmentUpdatedByDate(props.assessmentId)
		},
		(err) => {
			toast.add({
				severity: "error",
				summary: "Process Waste not saved",
				detail: ``,
				life: 3000,
			})
		}
	)
}
//PR
</script>
<style scoped>
/* .p-datatable .pi-spin {
	animation: spin 1s linear infinite !important;
} */
/* .btn-outline {
	background-color: white;
	color: var(--primary);
	border: 2px solid var(--primary);
	padding: 5px 10px;
	font-size: 12px;
	border-radius: 3px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.btn-outline:hover {
	background-color: #007bff;
	color: white;
} */
</style>
